import { Button, Typography } from "@material-tailwind/react";
import { useTranslation } from "react-i18next";
import tryDemoLowerBg from "../../Images/TgaTryDemoLowerBg.png";

interface TgaDocumentationProps {
    onViewDocumentationClickFunction: () => void
}

function TgaDocumentationComponent(props: TgaDocumentationProps) {
    const { t } = useTranslation();

    return (
        <div className="px-[25px] xl:px-[100px] relative w-full flex justify-center bg-#F6F6F6">
            <img src={tryDemoLowerBg} alt="TryDemoLowerBg" className="object-cover h-full min-h-[130px] w-full rounded-br-[22px] rounded-bl-[22px]" />
            <div className="absolute inset-0 flex flex-col-reverse xl:flex-row justify-center items-center gap-4 px-[30px]">
                <Button id="viewDocumentationBtn" onClick={props.onViewDocumentationClickFunction} className="bg-#FF8136 text-#161616 shadow-none hover:bg-#FF9800 hover:shadow-none min-w-[130px] h-[30px] xl:h-[40px] text-[12px] xl:text-[14px] leading-[12px] xl:leading-[14px] font-medium rounded-[5px] py-0">
                    {t("ViewDocumentation")}
                </Button>
                <Typography className="text-#282828 font-medium text-[12px] xl:text-[14px] 2xl:text-[18px] leading-[12px] xl:leading-[16px] 2xl:leading-[18px] xl:max-w-[450px] 2xl:max-w-none text-center">
                    {t("TgaDocumentationDescription")}
                </Typography>
                <hr className="bg-#282828 w-[1px] hidden xl:block xl:py-[30px]" />
                <Typography className="uppercase text-#282828 font-normal text-[14px] md:text-[16px] xl:text-[20px] 2xl:text-[26px] leading-[16px] xl:leading-[20px] 2xl:leading-[24px]">
                    TGA {t("Documentation")}
                </Typography>
            </div>
        </div>
    );
}

export default TgaDocumentationComponent;
